import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import ReactTable from "../../AppComponent/Table";
import {
  StetheAttendanceExportActions,
  setAttendanceExportgetlistActions,
  SetUserREtrieveActions,
} from "../../../Redux/Slice";
import AttedanceExport from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-08.svg";

const AttendanceExpor = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [withoutData, setwithoutData] = useState(true);
  const [Dob, setDob] = useState(["D.O.J", "D.O.B", "Designation"]);
const dateRangeRef = useRef(null);

  // const getCurrentAndNextMonthDates = () => {
  //   const currentDate = new Date();
  //   const currentMonth = currentDate.getMonth() + 1;
  //   const currentYear = currentDate.getFullYear();
  //   const currentdate = currentDate.getDate();

  //   const nextMonthDate = new Date(currentYear, currentMonth - 1); // Subtract 1 from currentMonth
  //   nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //   const currentMonthFormatted = `${currentYear}-${String(
  //     currentMonth
  //   ).padStart(2, "0")}-${currentdate}`;

  //   // Get the last date of the next month
  //   const nextMonthLastDate = new Date(
  //     nextMonthDate.getFullYear(),
  //     nextMonthDate.getMonth() + 1,
  //     0
  //   );
  //   const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(
  //     nextMonthDate.getMonth() + 1
  //   ).padStart(2, "0")}-${nextMonthLastDate.getDate()}`;

  //   return {
  //     currentMonth: currentMonthFormatted,
  //     nextMonth: nextMonthFormatted,
  //   };
  // };

  // Usage

  //   const getCurrentAndNextMonthDates = () => {
  //     const currentDate = new Date();
  //     const currentMonth = currentDate.getMonth() + 1;
  //     const currentYear = currentDate.getFullYear();
  //     const currentdate = currentDate.getDate();

  //     const nextMonthDate = new Date(currentYear, currentMonth); // No need to subtract 1 from currentMonth
  //     nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //     const currentMonthFormatted = `${currentYear}-${String(
  //       currentMonth
  //     ).padStart(2, "0")}-${currentdate}`;

  //     // Get the last date of the next month
  //     const nextMonthLastDate = new Date(
  //       nextMonthDate.getFullYear(),
  //       nextMonthDate.getMonth() + 1,
  //       0
  //     );
  //     const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(
  //       nextMonthDate.getMonth() + 1
  //     ).padStart(2, "0")}-${nextMonthLastDate.getDate()}`;

  //     return {
  //       currentMonth: currentMonthFormatted,
  //       nextMonth: nextMonthFormatted,
  //     };
  // };

  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
    const lastDateOfMonth = new Date(currentYear, currentMonth, 0);

    const startDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(firstDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;

    return {
      startDatemon,
      endDatemon,
    };
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();
  console.log(startDatemon, endDatemon, "startDate and endDate");

  // var { currentMonth, nextMonth } = getCurrentAndNextMonthDates();

  const [data, setdata] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: false,
    base_type: "day",
  });

  console.log("nextmonths", data);

  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();
  console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;

    //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);

  const [Data, setdatas] = useState({
    month: months,
    year: date.getFullYear(),
  });

  const [monthYearset, setMonthYear] = useState("");

  ////------month and year based filters-------------------------------
  const handleChange = (e) => {
    setMonthYear(e.target.value);
    const months = new Date(e.target.value);
    // months.getMonth()
    console.log(months.getMonth() + 1, "months", months.getFullYear());
    const selectedmonth =
      months.getMonth() < 10
        ? `0${months.getMonth() + 1}`
        : months.getMonth() + 1;
    setYearMpnth(`${months.getFullYear()}-${selectedmonth}`);
    console.log(e.target.value, "weurweydsfsd", selectedmonth);
    setdatas({
      ...Data,
      month: selectedmonth,
      year: months.getFullYear(),
    });
  };

  const Options = [
    {
      id: 1,
      value: "day",
      label: "DAY",
    },
    {
      id: 2,
      value: "time",
      label: "TIME",
    },
  ];

  //   -----Attendance---export get list call
  // useEffect(()=>{
  //     if(state.clientDetailsCall
  //         .ActiveForUserProfile == 4){
  //          const payload = {
  //              user:state.ClientBranchIDs.userProfileId,
  //              month: Data.month,
  //              year: Data.year,
  //          }
  //          dispatch(setAttendanceExportgetlistActions(payload))

  //     }
  // },[state.clientDetailsCall
  //     .ActiveForUserProfile , Data])

  ///---retrieve----calls-------------
  useEffect(() => {
    if (state.ClientBranchIDs.userProfileId != undefined) {
      const payload = {
        EditId: state.ClientBranchIDs.userProfileId,
      };
      dispatch(SetUserREtrieveActions(payload));
    }
  }, []);

  const columns = [
    {
      Header: "First Name",
      accessor: "first_name",
    },
    {
      Header: "Last Name",
      accessor: "last_name",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Role",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_role != undefined &&
            row.row.original.user_role != null &&
            row.row.original.user_role.role != undefined ? (
              <span>{row.row.original.user_role.role}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Casual Leave",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.working_status != undefined &&
            row.row.original.working_status != null &&
            row.row.original.working_status.casual_leave != undefined ? (
              <span>{row.row.original.working_status.casual_leave}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Leave Valid date",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.working_status != undefined &&
            row.row.original.working_status != null &&
            row.row.original.working_status.leave_valid_until != undefined ? (
              <span>{row.row.original.working_status.leave_valid_until}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Permission Valid date",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.working_status != undefined &&
            row.row.original.working_status != null &&
            row.row.original.working_status.permission_valid_until !=
              undefined ? (
              <span>
                {row.row.original.working_status.permission_valid_until}
              </span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Personal Leave",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.working_status != undefined &&
            row.row.original.working_status != null &&
            row.row.original.working_status.personal_leave != undefined ? (
              <span>{row.row.original.working_status.personal_leave}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        if (row.row.original.created_at != null) {
          const dateString =
            row.row.original.created_at != null
              ? row.row.original.created_at
              : "";
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;

          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

          return (
            <>
              <span>
                {row.row.original.created_at != null ? (
                  <>
                    {`${
                      row.row.original.created_at.slice(0, 10) +
                      "  " +
                      formattedTime
                    }`}
                  </>
                ) : (
                  <p>{"----"}</p>
                )}
              </span>
            </>
          );
        } else {
          return <span>{"----"}</span>;
        }
      },
    },
  ];

  const [selectedDates, setSelectedDates] = useState([]);
  const [datestae, setdatest] = useState(false);
  const formattedDates =
    selectedDates != null &&
    selectedDates.map((date) => {
      const isoString = date.toISOString();
      return isoString.substring(0, 10);
    });

  const handleDateChange = (e) => {
  if (e && e.length > 0) {
    setdatest(true);
    setSelectedDates(e);

    // Convert all selected dates to "YYYY-MM-DD"
    const converted = e.map((newValue) => {
      const tzoffset = new Date().getTimezoneOffset() * 60000;
      return new Date(newValue - tzoffset)
        .toISOString()
        .split("T")[0]; // ← Only date part
    });


    // When multiple dates are selected → treat as range
    if (converted.length >= 2) {
      const [from, to] = converted;

      setdata((prev) => ({
        ...prev,
        from_date: from,
        to_date: to,
        range: true,
      }));
    } else {
      // Single date selection
      setdata((prev) => ({
        ...prev,
        from_date: converted[0],
        to_date: converted[0],
        range: false,
      }));
    }
  }

  };

  console.log(formattedDates, "formattedDates");
  // useEffect(() => {
  //   if (datestae) {
  //     setdata({
  //       ...data,
  //       from_date: formattedDates[0],
  //       to_date: formattedDates[1],
  //       range: true,
  //     });
  //   }
  // }, [selectedDates]);

  const attendanceexportEmp = (e, statement, values) => {
    console.log(values, statement, e, "auysfdasdasdyasdlas",data);
    Swal.fire({
      title: `Are you sure, do you want to export the attendance  ${
        statement ? "based on this month to end of the  month" : ""
      }?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Export it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payloads = {
          export_type: "employee",
          client_id: "",
          user_id: values.user_id,
          data: values.data,
          Dob: [],
        };
        dispatch(StetheAttendanceExportActions(payloads));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  const HandleChanges = (e) => {
    //    console.log(e.target.value, "sdfsdgfweifi");

    setdata({ ...data, base_type: e.target.value });
  };

  const pagesize = (arg) => {};

  const pageindex = (arg) => {};

  const handlePrevious = (e) => {};
  const handleNext = (e) => {};
  const tochange = (e) => {};
 const GotoEnteredPage=(e)=>{};
 const openMe = ()=>{
  const rsAnimFade = document.querySelector('.rs-anim-fade');
  if (rsAnimFade) {
    rsAnimFade.style.setProperty('left', '428.344px ', 'important');
    rsAnimFade.style.setProperty('top', '158.109px', 'important');   
  }
 }

 const CloseDateRange = ()=>{
  const rsAnimFade = document.querySelector('.rs-anim-fade');
  if (rsAnimFade) {
    rsAnimFade.style.setProperty('display', 'none', 'important');
    // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
  }
 }

 const getZoomFactor = () => {
  const zoom = document.body.style.zoom;
  return zoom ? parseFloat(zoom) / 100 : 1;
};

const alignDateRangePicker = (pickerNode) => {
  const picker =
    pickerNode?.root || pickerNode?.container || pickerNode;

  const popup = document.querySelector(
    ".rs-picker-popup.rs-picker-popup-daterange"
  );

  if (!picker || !popup) return;

  const zoom = getZoomFactor();
  const rect = picker.getBoundingClientRect();

  const popupWidth = popup.offsetWidth;
  const popupHeight = popup.offsetHeight;

  const viewportWidth = window.innerWidth / zoom;
  const viewportHeight = window.innerHeight / zoom;

  const scrollX = window.scrollX / zoom;
  const scrollY = window.scrollY / zoom;

  let left = rect.right / zoom - popupWidth + scrollX;
  let top = rect.bottom / zoom + 8 + scrollY;

  if (left < 8) left = 8;
  if (left + popupWidth > viewportWidth - 8) {
    left = viewportWidth - popupWidth - 8;
  }

  if (top + popupHeight > viewportHeight + scrollY - 8) {
    top = rect.top / zoom - popupHeight - 8 + scrollY;
  }

  popup.style.position = "absolute";
  popup.style.left = `${left}px`;
  popup.style.top = `${top}px`;
};
  return (
    <>
      <div
        //className="DatePicker daterangeinclientdetails"
        className="row  mt-4"
        style={{ paddingLeft: "20px", paddingRight: "20px" }}
      >
        {/* 
<div className="col-3">
                              <label style={{ marginLeft: "12px" }}>
                                <input
                                  type="checkbox"
                                  value={withoutData}
                                  onChange={(e) => {
                                    if (withoutData) {
                                      setDob([]);
                                    } else {
                                      setDob(["D.O.J", "D.O.B", "Designation"]);
                                    }

                                    setwithoutData(!withoutData);
                                  }}
                                />

                                <span style={{ marginLeft: "12px" }}>
                                  {withoutData
                                    ? "without (DOB , DOJ , Designation) Sheet will be Export"
                                    : "with (DOB, DOJ, Designation) Sheet will be Export"}
                                </span>
                              </label>
                            </div> */}

        <div className="col-3">
          <select
            style={{
              width: "100%",
              padding: "10px",
              marginTop: "10px",
            }}
            class="form-select form-select-lg mb-3"
            aria-label=".form-select-lg example"
            name="marital_status"
            readOnly={state.NumberCounts.Editable == 1 ? true : false}
            onChange={(e) => {
              HandleChanges(e);
            }}
          >
            {Options.map((item) => (
              <option
                value={item.value}
                // selected={
                //   data.marital_status != undefined
                //     ? data.marital_status.toLowerCase() ==
                //       item.value.toLowerCase()
                //     : null
                // }
              >
                {item.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-3 mt-2 ">
          <DateRangePicker
            className="Dateranger"
            //  style={{ width: 270, padding: 10 }}
            placeholder="From-To"
            onChange={handleDateChange}
            showHeader={false}
            size="lg"
                                                                  ref={dateRangeRef}

          onOpen={() => {
            
    setTimeout(() => {
      alignDateRangePicker(dateRangeRef.current);
    }, 80);
  }}


  style={{
    width: "100%",
    padding: "0px 5px",
  }}
  placement="bottomEnd"
                         editable={false}   // ✅ FULLY disables typing & arrow keys

            value={selectedDates}
          />
        </div>
        <div className=" col-3   mt-2 actions">
          <button
            type="button"
            class="btn Status"
             style={{display:"flex"}}
            onClick={(e) => {
              // e.stopPropagation();
              const payloads = {
                export_type: "employee",
                client_id: "",
                user_id: state.ClientBranchIDs.userProfileId,
                data: data,
              };

              if (
                startDatemon == data.from_date &&
                endDatemon == data.to_date
              ) {
                attendanceexportEmp(e, true, payloads);
              } else {
                attendanceexportEmp(e, false, payloads);
              }
            }}
          >
            Export

                               <span  className="AttendanceExportImage">
                    <img src={AttedanceExport}/>
                  </span>
          </button>
        </div>
      </div>

      <div>
        {/* <div
          style={{
            position: "absolute",
            height: "71px",
            zIndex: "1",
            width: "25%",
            display: "flex",
            justifyContent: "flex-start",
            // paddingRight: "220px",
            alignItems: "flex-start",
            flexDirection: "column",
            right: "128px",
          }}
          className="innnermontfilters"
        >
          <div style={{ display: "inline", marginTop: "6px" }}>
            <p>Month</p>
            <input
              type="month"
              value={yearAndMonth}
              onChange={(e) => {
                handleChange(e);
              }}
            />
          </div>
        </div> */}

        <ReactTable
          data={[state.UserRetrieve.userRetrireve]}
          columns={columns}
          currentPage={1}
          totalItems={10}
          pagesize={pagesize}
          dtpagesize={20}
          pageindex={pageindex}
          datacount={10}
          onPrevious={handlePrevious}
          onNextpage={handleNext}
          GotoEnteredPage={GotoEnteredPage}
      dtpageindex={1}
    
          // onChange={tochange}
          Search={true}
        />
      </div>

      {/* </div> */}
    </>
  );
};

export default AttendanceExpor;
